<template>
  <div>
    <br />
    <h2 class="ViewHeading">Reports</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >
      <b-card v-if="UserProfile === 'SEN'">
        <SenReports />
        </b-card>
      <b-card v-if="UserProfile != 'SEN'" no-body>
        <b-tabs card>
          <b-tab lazy active>
            <template #title> Clarence Reports <BIconEye></BIconEye> </template>
            <b-card-text>
              <ClarenceReports></ClarenceReports>
            </b-card-text>
          </b-tab>
          <!-- <b-tab lazy>
            <template #title>
              AG Washbasin Unit Reports <BIconDroplet></BIconDroplet>
            </template>
            <b-card-text>
              <WashbasinReports></WashbasinReports>
            </b-card-text>
          </b-tab>
          <b-tab lazy>
            <template #title>
              Water Management Reports
              <BIconClipboardCheck></BIconClipboardCheck>
            </template>
            <b-card-text>
              <ReportsWaterTesting></ReportsWaterTesting>
            </b-card-text>
          </b-tab>
          <b-tab lazy>
            <template #title>
              Super User Reports <BIconFolder></BIconFolder>
            </template>
            <b-card-text>
              <SuperUserReports></SuperUserReports>
            </b-card-text>
          </b-tab> -->
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BIconEye,
  // BIconDroplet,
  // BIconClipboardCheck,
  // BIconFolder,
} from "bootstrap-vue";
import ClarenceReports from "./ReportsClarence.vue";
import SenReports from "@/components/ReportSEN.vue";
// import WashbasinReports from "../views/ReportsWashbasin.vue";
// import SuperUserReports from "../views/SuperUserReports.vue";
// import ReportsWaterTesting from "../views/ReportsWaterTesting.vue";

export default {
  computed: {},
  components: {
    BIconEye,
    // BIconDroplet,
    // BIconClipboardCheck,
    // BIconFolder,
    ClarenceReports,
    SenReports,
    // WashbasinReports,
    // SuperUserReports,
    // ReportsWaterTesting,
  },

  data() {
    return {
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserProfile: localStorage.getItem("profileportal"),
      UserAccess: localStorage.getItem("accessGroup"),
    };
  },

  beforeMount() {},

  mounted() {
   
  },

  methods: {
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },
    userfullname() {
      this.userfullname = localStorage.getItem("fullname");
      return this.userfullname;
    },

  },
};
</script>

<style>

#Table {
  margin: auto;
  text-align: center;
}


</style>
